import { Api } from '../../utils/api/api';
import { setData, setError, startFetching } from '../actions';
import { accountActionTypes as ACTION } from '../actionTypes';
import CONSTANTS from '../../constants/api.constants';

export const forgotPassword = (arg) => {
  return async (dispatch) => {
    try {
      dispatch(startFetching(ACTION.FORGOT_PASSWORD_REQUEST));
      const data = await Api.post(`${CONSTANTS.baseUrl}${CONSTANTS.forgotPassword}`, arg.payload);
      if (data.status === 200) {
        dispatch(
          setData(ACTION.FORGOT_PASSWORD_SUCCESS, {
            payload: data.data.payload,
            message: data.data.message,
          })
        );
      }
    } catch (error) {
      if (error && error.response && error.response.status === 400)
        dispatch(setError(ACTION.FORGOT_PASSWORD_FAILURE, error.response.data.message));
      else {
        dispatch(setError(ACTION.FORGOT_PASSWORD_FAILURE, 'Something Went Wrong!'));
      }
    }
  };
};

export const resetPassword = (arg) => {
  return async (dispatch) => {
    try {
      dispatch(startFetching(ACTION.RESET_PASSWORD_REQUEST));
      const data = await Api.post(`${CONSTANTS.baseUrl}${CONSTANTS.resetPassword}`, arg.payload, {
        resetPasswordFlow: true,
      });
      if (data.status === 200) {
        dispatch(
          setData(ACTION.RESET_PASSWORD_SUCCESS, {
            payload: data.data.payload,
            message: data.data.message,
          })
        );
      }
    } catch (error) {
      if (error.response.status === 400) {
        dispatch(setError(ACTION.RESET_PASSWORD_FAILURE, error.response.data.message));
      } else {
        dispatch(setError(ACTION.RESET_PASSWORD_FAILURE, 'Something Went Wrong!'));
      }
    }
  };
};
